import { createApp } from 'vue';
import App from './App.vue';
import './assets/css/global.css';
import vuetify from './plugins/vuetify.js';
import 'vuetify/styles';
// After Vuetify's styles so their equal-specificity rules don't win.
import './assets/css/dialogs.css';
import './assets/css/tables.css';
import './assets/css/buttons.css';
import './assets/css/inputs.css';
import './assets/css/menus.css';
import './assets/css/cards.css';
import './assets/css/forms.css';
import router from './router';
import store from './store';
import mixins from './mixins.js';
import { installBranding, loadBranding } from './branding';
import { installAppearance } from './composables/useAppearance';
import VueJsonToCsv from "vue-json-to-csv";
import FadeAwayMessage from './components/Alerts/FadeAwayMessage.vue'; // Use .vue directly for simplicity

const app = createApp(App);
window.addEventListener('error', (e) => {
  if (e.message.includes('ResizeObserver loop limit exceeded') || 
      e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
  }
});
// Register global component
app.config.productionTip = false;
app.component('fade-away-message-component', FadeAwayMessage);
app.component("vue-json-to-csv", VueJsonToCsv);

app.use(vuetify);
app.use(router);
app.use(store);
app.mixin(mixins);

installBranding(app);
installAppearance(vuetify);

// Load the school's branding first so the first paint already shows the
// right name, logo and colour.
loadBranding(vuetify).finally(() => app.mount('#app'));